/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import PredictionService from '../services/PredictionService';
import PredictionUtils from '../../utils/PredictionUtils';
import {FETCH_APPS_BASED_AUTORANKER} from '../types';

export const fetchMLAppRanking = () => async(dispatch: Function) => {
	const predictionService = new PredictionService();
	const data = PredictionUtils.getRequestBodyBasedOnModel('apps-entitlement-based-autoranker');
	const res = await predictionService.fetchPrediction(data);

	dispatch({
		type: FETCH_APPS_BASED_AUTORANKER,
		payload: res,
	});
};
